import styled from "styled-components";
import {
  TransformWrapper,
  TransformComponent,
  ReactZoomPanPinchContentRef,
} from "react-zoom-pan-pinch";
import { useEffect, useRef } from "react";
import { CardSlot } from "./CardSlot";
import { CardTitle } from "./CardTitle";
import { useOrientation } from "@uidotdev/usehooks";

const Frame = styled.div`
  @media (orientation: portrait) {
    width: 90vw;
    aspect-ratio: 1.5423;
    --w: calc(90vw / 1000);
    --h: calc(90vw / 1.5423 / 1000);
  }

  @media (orientation: landscape) {
    height: calc(72vh);
    aspect-ratio: 1.5423;
    --w: calc(72vh * 1.5423 / 1000);
    --h: calc(72vh / 1000);
  }

  position: relative;
  img {
    pointer-events: auto !important;
  }
`;

const CardBackground = styled.div<{ background: string }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${({ background }) =>
    encodeURI(`/assets/resources/${background}`)});
  background-size: contain;
  border-radius: calc(5 * var(--u));
`;

const CardSlotsContainer = styled.div<{ template: string }>`
  position: absolute;
  top: calc(var(--h) * 260);
  left: calc(var(--w) * 75);
  height: calc(var(--h) * 631);
  width: calc(var(--w) * 850);

  display: flex;
  flex-direction: row;
  flex-wrap: no-wrap;

  font-size: calc(var(--h) * 50) !important;

  em {
    display: inline !important;
  }

  // A and B columns
  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    // rows
    & > div {
      flex: 1;
    }
  }

  // A1
  & > div:nth-child(1) > div:nth-child(1) > p {
    padding-bottom: calc(10 * var(--h));

    img {
      min-height: 0;
      width: auto;
    }
  }

  // B1
  & > div:nth-child(2) > div {
    width: 100%;
    text-align: left;
  }

  ${({ template }) => {
    switch (template) {
      case "1":
        return `
          & > div:nth-child(1) {
            flex: 0 0 30%;
            img {
              display: block;
            }
          }
          & > div:nth-child(2) {
            img {
              height: calc(60 * var(--h));
            }
          }
        `;
      case "2":
        return `
          & > div:nth-child(1) {
            flex: 0 0 30%;

            p {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            }
          }
          & > div:nth-child(2) > div {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: start;
              justify-content: center;
              img {
                height: calc(60 * var(--h));
              }
          }
        `;
      case "3":
        return `
            & > div:nth-child(1) {
              flex: 0 0 30%;

              p {
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              }
            }
            & > div:nth-child(2) > div {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: start;
              justify-content: center;
              padding-right: calc(10 * var(--w));
              img {
                height: calc(60 * var(--h));
              }
          }
          `;
      case "4":
        return `
            & > div:nth-child(1) {
              flex: 0 0 43%;
              
              p {
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              }
            }
            & > div:nth-child(2) > div {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: start;
              justify-content: center;
              padding-right: calc(20 * var(--w));
              img {
                height: calc(60 * var(--h));
              }
          }
          `;
      case "5":
        return `
                & > div:nth-child(1) > div {
                  height: 100%;
                  display: flex;
                  flex-direction: column;
                  align-items: start;
                  justify-content: center;
                  text-align: left;
                  padding: 0 calc(20 * var(--w));
                  align-self: flex-start;
              }
              `;
      case "6":
        return `
          & > div:nth-child(1) > div {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: left;
            padding: 0 var(--u);
            width: 100%;

            h2 {
              text-align: center;
              font-size: inherit;
              color: inherit;
              margin: 0;
              font-weight: bold;
            }

            ul {
              align-self: flex-start;
            }
          }
        `;
      /*       case "swas:6":
        return `
          & > div:nth-child(1) > div {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
          }
        `; */
      case "7": // terrain
        return `
          & > div:nth-child(1) {
            flex: 0 0 37%;
            padding-bottom: 1%;
            & > div:nth-child(1) {
              flex: 0 0 78%;
            }
            & > div:nth-child(2) {
              p {
                height: 100%;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: center;
                img {
                  height: 100%;
                  min-height: 0;
                }
              }
            }
          }
          & > div:nth-child(2) {
            & > div:nth-child(1) {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: start;
              justify-content: center;
              img {
                height: calc(60 * var(--h));
              }
              padding-left: var(--u);
              padding-right: var(--u);
            }
            & > div:nth-child(2) {
              flex: 0 0 auto;
              width: 100%;
              aspect-ratio: 3;
              background-size: contain;
              background-repeat: no-repeat;
              background-image: url("/assets/resources/Terrains Cards/Def/73-M44V2-Cards-Helper-BG2-long2.png");
              

              p {
                height: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                padding: 0 2%;
                gap: 2%;

                img {
                  display: block;
                  padding: 0;
                  flex: 1;
                  width: 40%;
                }
              }
            }
          }
        `;
      case "8": // terrain
        return `
          & > div:nth-child(1) {
            flex: 0 0 37%;
            padding-bottom: 1%;
            & > div:nth-child(1) {
              flex: 0 0 78%;
            }
            & > div:nth-child(2) {
              p {
                height: 100%;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: center;
                img {
                  height: 100%;
                  min-height: 0;
                }
              }
            }
          }
          & > div:nth-child(2) {
            & > div:nth-child(1) {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: start;
              justify-content: center;
              img {
                height: calc(60 * var(--h));
              }
              padding-left: var(--u);
              padding-right: var(--u);
            }
            & > div:nth-child(2) {
              flex: 0 0 auto;
              width: 100%;
              aspect-ratio: 7.5897;
              background-size: contain;
              background-repeat: no-repeat;
              background-image: url("/assets/resources/Terrains Cards/Def/73-M44V2-Cards-Helper-BG2-long2.png");
              

              p {
                height: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                padding: 0 calc(var(--w) * 20);
                gap: calc(var(--w) * 20);

                img {
                  display: block;
                  padding: 0;
                  flex: 1;
                  min-width: 0;
                }
              }
            }
          }
        `;
      case "9": // terrain with 2 rows of def
        return `
          & > div:nth-child(1) {
            flex: 0 0 37%;
            padding-bottom: 1%;
            & > div:nth-child(1) {
              flex: 0 0 78%;
            }
            & > div:nth-child(2) {
              p {
                height: 100%;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: center;
                img {
                  height: 100%;
                  min-height: 0;
                }
              }
            }
          }
          & > div:nth-child(2) {
            & > div:nth-child(1) {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: start;
              justify-content: center;
              img {
                height: calc(60 * var(--h));
              }
              padding-left: var(--u);
              padding-right: var(--u);
            }
            & > div:nth-child(2) {
              flex: 0 0 17%;
              max-height: 17%;
              width: 50%;
              display: block !important;
              background-size: contain;
              background-repeat: no-repeat;
              background-image: url("/assets/resources/Terrains Cards/Def/73-M44V2-Cards-Helper-BG2-short.png");
              
              p {
                height: 100%;
                max-height: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                padding: 0 4%;
                gap: 2%;

                img {
                  display: block;
                  padding: 0;
                  flex: 1;
                  width: 40%;
                }
              }
            }
            & > div:nth-child(3) {
              flex: 0 0 19.3%;
              background-size: contain;
              background-repeat: no-repeat;
              background-image: url("/assets/resources/Terrains Cards/Def/73-M44V2-Cards-Helper-BG2-long2.png");
              

              p {
                height: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                padding: 0 2%;
                gap: 2%;

                img {
                  display: block;
                  padding: 0;
                  flex: 1;
                  width: 40%;
                }
              }
            }
          }
        `;
    }
  }}
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export type CardSlotProps = any;

export type CardProps = {
  type: "terrain" | "troops";
  id: number;
  title: string;
  titleSize: number;
  fontSize: number;
  images: string[];
  background: string;
  template?: number;
  titleBackground: string;
  slots: { [key: string]: CardSlotProps };
};

export function Card(props: CardProps) {
  const slots = props.slots ?? {};

  const abc = "ABCDEF";
  const columns = Object.keys(slots).reduce((columns, key) => {
    if (!columns[abc.indexOf(key[0])]) {
      columns[abc.indexOf(key[0])] = [];
    }
    columns[abc.indexOf(key[0])][Number(key.slice(1))] = slots[key];
    return columns;
  }, [] as CardSlotProps[][]);

  const wrapperRef = useRef<ReactZoomPanPinchContentRef>(null);
  const orientation = useOrientation();
  useEffect(() => {
    setTimeout(() => {
      wrapperRef.current?.resetTransform();
      wrapperRef.current?.zoomOut();
    });
  }, [props, orientation]);

  return (
    <Container>
      <TransformWrapper
        ref={wrapperRef}
        centerOnInit
        onInit={() => {
          console.log("View got initialized");
        }}
      >
        <TransformComponent
          wrapperStyle={{
            width: "100%",
            height: "100%",
          }}
        >
          <Frame>
            <CardBackground background={props.background} />
            <CardTitle {...props} />
            <CardSlotsContainer
              template={`${props.template || 0}`}
              className={`template-${props.template || 0}`}
            >
              {columns.map((column, columnIndex) => (
                <div key={`${props.type}:${props.id}:${columnIndex}`}>
                  {column.map((md, rowIndex) => (
                    <CardSlot
                      md={md}
                      fontSize={props.fontSize}
                      key={`${props.type}:${props.id}:${columnIndex}:${rowIndex}`}
                    />
                  ))}
                </div>
              ))}
            </CardSlotsContainer>
          </Frame>
        </TransformComponent>
      </TransformWrapper>
    </Container>
  );
}
